// 這是Webpack掛載起始點
import Layout from './layout.vue'
import Main from './main.vue'
import New from '@stations/.components/new.vue'
import Edit from '@stations/.components/edit.vue'

const main_router = 'stations'
const new_router = 'new_station'
const edit_router = 'edit_station'

const router = [
    {
        path: '',
        component: Main,
        name: 'stations',
        meta: {
            api_name: 'api_v1_provider_stations',
            breadcrumb: [main_router],
            btns: [new_router]
        }
    },
    {
        path: 'new',
        component: New,
        name: 'new_station',
        meta: {
            api_name: 'api_v1_provider_stations_create',
            breadcrumb: [main_router, new_router]
        }
    },
    {
        path: ':station_identity/edit',
        component: Edit,
        name: 'edit_station',
        meta: {
            api_name: 'api_v1_provider_station_update',
            breadcrumb: [main_router, edit_router]
        }
    },
]

export default router
